import type { PlayersDirectoryProfileFilter } from '../../../services/api';

export type FriendsGender = 'any' | 'male' | 'female';

/** A range of the stepper; `max` is open-ended when undefined. */
export type FilterRange = { min: number; max?: number };

/** Index 0 is "Any" on both steppers; the minus / plus buttons walk through the rest. */
export const AGE_RANGES: Array<FilterRange | null> = [
	null,
	{ min: 18, max: 25 },
	{ min: 26, max: 50 },
	{ min: 51 },
];

export const LEVEL_RANGES: Array<FilterRange | null> = [
	null,
	{ min: 1, max: 10 },
	{ min: 10, max: 20 },
	{ min: 20, max: 30 },
	{ min: 30 },
];

export const GENDERS: FriendsGender[] = ['any', 'male', 'female'];

export type FriendsFilterValues = {
	gender: FriendsGender;
	/** Index into AGE_RANGES. */
	age: number;
	/** Index into LEVEL_RANGES. */
	level: number;
	location: string;
};

export const DEFAULT_FRIENDS_FILTER: FriendsFilterValues = {
	gender: 'any',
	age: 0,
	level: 0,
	location: '',
};

export const formatRange = (range: FilterRange | null, anyLabel: string) => {
	if (!range) return anyLabel;
	return range.max === undefined ? `${range.min}+` : `${range.min} - ${range.max}`;
};

/** The popup's values as the friends directory's query parameters; "Any" sends nothing. */
export const toDirectoryProfileFilter = (
	filter: FriendsFilterValues,
): PlayersDirectoryProfileFilter => {
	const age = AGE_RANGES[filter.age];
	const level = LEVEL_RANGES[filter.level];
	const location = filter.location.trim();

	return {
		...(filter.gender !== 'any' ? { gender: filter.gender === 'male' ? 'Male' : 'Female' } : {}),
		...(age ? { minAge: age.min, ...(age.max !== undefined ? { maxAge: age.max } : {}) } : {}),
		...(level
			? { minLevel: level.min, ...(level.max !== undefined ? { maxLevel: level.max } : {}) }
			: {}),
		...(location ? { location } : {}),
	};
};

export const isFriendsFilterActive = (filter: FriendsFilterValues) =>
	Object.keys(toDirectoryProfileFilter(filter)).length > 0;
